import API from "serviceshift-ui/api-client";
import Pagination from "@/lib/pagination";

export default {
  clearMergeAccounts({ commit }) {
    commit("replace", {
      state: "mergeAccounts",
      data: {
        destination: {
          customer: null,
          options: []
        },
        duplicate: {
          customer: null,
          options: []
        }
      }
    });
  },
  createCustomer(_, data) {
    return API.makeRequest("/v2/customers", {
      method: "POST",
      data
    });
  },
  createPaymentMethod(_, params) {
    const { url, ...payload } = params;
    if (url) {
      return API.makeRequest(url, {
        method: "POST",
        data: payload
      });
    } else {
      return new Promise((resolve, reject) => {
        reject({ message: "No create payment method URL found." });
      });
    }
  },
  createCustomerMembership(_, { customerId, data }) {
    return API.makeRequest(`/v2/customers/${customerId}/memberships`, {
      method: "POST",
      data
    });
  },
  deleteCustomerMembership(_, { url }) {
    return API.makeRequest(url, {
      method: "DELETE"
    });
  },
  deletePaymentMethod(_, { payment_method_delete_url }) {
    if (payment_method_delete_url) {
      return API.makeRequest(payment_method_delete_url, {
        method: "DELETE"
      });
    } else {
      return new Promise((resolve, reject) => {
        reject({ message: "No delete payment method URL found." });
      });
    }
  },
  fetchMembershipChanges(_, { customerId, data }) {
    return API.makeRequest(`/v2/customers/${customerId}/memberships/validate`, {
      method: "POST",
      data
    });
  },
  fetchPaymentReceivers({ commit }, { payment_receivers_url }) {
    return API.makeRequest(payment_receivers_url, {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "receivers",
        data: res.data
      });
    });
  },
  // fetchDepartments({ commit }) {
  //   return API.makeRequest("/v2/departments", {
  //     method: "GET"
  //   }).then((res) => {
  //     commit("replace", {
  //       state: "departments",
  //       data: res.data
  //     });
  //   });
  // },
  fetchTechnicians({ commit }) {
    return API.makeRequest("/v2/technicians", {
      method: "GET"
    }).then((res) => {
      commit("replace", {
        state: "technicians",
        data: res.data
      });
    });
  },
  fetchTechniciansForJob({ commit }, { jobId }) {
    return API.technician.getAllForJob(jobId).then((res) => {
      commit("replace", {
        state: "techniciansForJob",
        data: res.data
      });
    });
  },
  async clearCurrentUser({ commit }) {
    commit("replace", {
      state: "currentUser",
      data: null
    });
  },
  async fetchUser({ commit }, { id, returnOnly }) {
    const res = await API.makeRequest(`/admin/v4/users/${id}`, {
      method: "GET"
    });
    // Handle lookups without setting currentUser
    if (!returnOnly) {
      commit("replace", {
        state: "currentUser",
        data: res.data
      });
    }
    return res;
  },
  async fetchCustomerAddressById(_, { addressId }) {
    const res = await API.makeRequest(`/admin/v4/addresses/${addressId}`, {
      method: "GET"
    });
    return res.data;
  },
  async fetchCustomerAddresses(
    { commit },
    { customerId, search, archived = false }
  ) {
    const addressPager = new Pagination({
      baseURL: "/admin/v4/addresses",
      page: 1,
      perPage: 10000, // Supports legacy UIs requiring all addresses
      filteredBy: [
        { key: "customer_id", value: customerId },
        { key: "archived", value: archived }
      ]
    });
    if (search) {
      addressPager.filter({ key: "search", value: search });
    }
    const res = await addressPager.getData();
    commit("replace", {
      state: "currentUserAddresses",
      data: res.data.data
    });
  },
  lookupCustomer(_, searchParams) {
    const params = {};

    Object.keys(searchParams).forEach((key) => {
      params[`search[${key}]`] = searchParams[key];
    });

    return API.makeRequest(`/v1/users/customer_search`, {
      method: "GET",
      contentType: "application/json",
      params
    });
  },
  mergeAccounts(_, { data }) {
    return API.makeRequest(`/v2/customers/merge`, {
      method: "POST",
      data
    });
  },
  mergeAddresses({ dispatch }, { id, data }) {
    return API.makeRequest(`/v2/customers/${id}/addresses/merge`, {
      method: "POST",
      data
    }).then(() => {
      dispatch("fetchUser", {
        id
      });
    });
  },
  sendPasswordReset(_, { id, email }) {
    return API.user.sendPasswordReset(id).then(() => {
      window.notify.success(`Password reset email sent to ${email}!`);
    });
  },
  setAccountingKey(_, { link, data }) {
    return API.makeRequest(link, {
      method: "PUT",
      data
    });
  },
  setCurrentUser({ commit }, data) {
    commit("replace", {
      state: "currentUser",
      data
    });
  },
  setMergeAccounts({ commit }, { type, data }) {
    commit("update", {
      state: "mergeAccounts",
      data: { [type]: data }
    });
  },
  swapMergeAccounts({ commit, state }) {
    return new Promise((resolve) => {
      const destination = state.mergeAccounts.destination;
      const duplicate = state.mergeAccounts.duplicate;
      const data = {
        destination: duplicate,
        duplicate: destination
      };
      commit("replace", {
        state: "mergeAccounts",
        data
      });
      resolve(data);
    });
  },
  updateCustomerMembership(_, { url, data }) {
    return API.makeRequest(url, {
      method: "PUT",
      data
    });
  },
  updateUser({ commit }, { id, data }) {
    return API.makeRequest(`/v1/users/${id}`, {
      method: "PUT",
      data
    }).then((response) => {
      commit("update", {
        state: "currentUser",
        data: response.data
      });
    });
  },
  createUserAddress({ commit, state }, { user_id, data }) {
    return API.makeRequest(`/v2/customers/${user_id}/addresses`, {
      method: "POST",
      data
    }).then((response) => {
      const diffArray = response.data.addresses.filter(
        (ax) => !state.currentUserAddresses.some((bx) => bx.id === ax.id)
      );
      commit("update", {
        state: "currentUser",
        data: response.data
      });
      if (diffArray.length) {
        return diffArray[0];
      }
    });
  },
  updateUserAddress({ commit, state }, { user_id, address_id, data }) {
    return API.makeRequest(`/v2/customers/${user_id}/addresses/${address_id}`, {
      method: "PUT",
      data
    }).then((response) => {
      const diffArray = response.data.addresses.filter(
        (ax) => !state.currentUserAddresses.some((bx) => bx.id === ax.id)
      );
      commit("update", {
        state: "currentUser",
        data: response.data
      });
      if (diffArray.length) {
        return diffArray[0];
      }
    });
  },
  validateCoverageArea(_, params) {
    return API.user.validateCoverageArea(params);
  },
  updateCustomerArchiveStatus(
    { commit, state },
    { action_url, update_current_user = false }
  ) {
    return API.makeRequest(action_url, {
      method: "PUT"
    }).then((response) => {
      if (state.currentUser && update_current_user) {
        commit("update", {
          state: "currentUser",
          data: response.data
        });
      }
    });
  },
  validateAccountingKey(_, { link, params }) {
    return API.makeRequest(link, {
      method: "GET",
      params
    });
  }
};
